// pages/FormViewerPage/sections/orderSummary/SubmitButton.tsx — Tombol submit pesanan
import React from 'react';
import SpinnerIcon from '../../../../components/icons/SpinnerIcon';
import { getAnimationClasses } from '../../components/FadeInBlock';
import { ms } from '../../../../locales/ms';

export const SubmitButton: React.FC<{ hook: any; isSimpleLead: boolean }> = ({ hook, isSimpleLead }) => {
    const { form, isSubmitting, currentCombination, herbalClaimMode } = hook;

    return (
        <button type="submit" disabled={(!currentCombination && (form?.variantCombinations?.length || 0) > 0) || isSubmitting}
            className={'w-full mt-6 bg-orange-600 text-white font-bold rounded-lg hover:bg-orange-700 disabled:bg-orange-400 disabled:cursor-not-allowed flex flex-col items-center justify-center p-2 min-h-[4rem] transition-colors ' + (form.ctaSettings?.animationEnabled ? getAnimationClasses(form.ctaSettings?.animationType) : '')}
            style={form.ctaSettings?.buttonColor ? { backgroundColor: form.ctaSettings.buttonColor } : {}}>
            {isSubmitting ? (
                <SpinnerIcon className="w-6 h-6 animate-spin" />
            ) : (!form?.variantCombinations?.length || currentCombination) ? (
                <span className="text-lg leading-tight flex items-center justify-center gap-2">
                    {isSimpleLead && herbalClaimMode === 'claim_ongkir' ? (
                        <>
                            <span className="text-xl leading-none">🎁</span>
                            <span>Kirim & Ambil Potongan Ongkir</span>
                        </>
                    ) : isSimpleLead ? (
                        <>
                            {form.ctaSettings?.buttonIcon ? (
                                <span className="text-xl leading-none">{form.ctaSettings.buttonIcon}</span>
                            ) : (
                                <span className="text-xl leading-none">💬</span>
                            )}
                            <span>{form.ctaSettings?.mainText || 'Lanjut Chat WhatsApp CS'}</span>
                        </>
                    ) : (
                        <>
                            {form.ctaSettings?.buttonIcon && <span className="text-xl leading-none">{form.ctaSettings.buttonIcon}</span>}
                            <span>{form.ctaSettings?.mainText || ms(form, m => m.submitOrder, 'Kirim Pesanan')}</span>
                        </>
                    )}
                </span>
            ) : 'Varian tidak tersedia'}
        </button>
    );
};
